/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ValidateCouponRequestPlanSlug = typeof ValidateCouponRequestPlanSlug[keyof typeof ValidateCouponRequestPlanSlug] | null;


export const ValidateCouponRequestPlanSlug = {
  solo: 'solo',
  growth: 'growth',
  business: 'business',
} as const;
